// @flow
import _ from 'lodash'
import React, { Component } from 'react'
import type { OptionType, GroupedOptionType, AutomatedRuleTableData } from '../types'

import Action from '../AutomatedRulesEdit/Action'
import Conditions from '../AutomatedRulesEdit/Conditions'
import { BodyRow, Cell, MenuItem } from '../../components/MainTable'
import Menu from '../CampaignsTable/Menu'
import styled, { type StyledComponent } from 'styled-components'
import AjaxStateSwitcher from '../controls/AjaxStateSwitcher'
import StateSwitcher from '../controls/StateSwitcher'

const MenuLink: StyledComponent<Object, any, any> = styled.a`
  text-decoration: none;
`

const AudienceNameWrapper: StyledComponent<Object, any, any> = styled.div`
  padding-bottom: 5px;
`

export const BoldText: StyledComponent<Object, any, any> = styled.span`
  font-weight: bold;
`

type Props = {
  t: Function,
  rule: AutomatedRuleTableData,
  audienceOptions: Array<GroupedOptionType>,
  conditionOptions: Array<OptionType>,
  actionOptions: Array<OptionType>,
  checked: boolean,
  onChange: Function,
  onDelete: Function
}

export default class AutomatedRulesTableRow extends Component<Props> {
  render() {
    const { t, rule, conditionOptions, actionOptions, checked, onDelete } = this.props
    return (
      <BodyRow>
        <Cell alignRight>
          <AjaxStateSwitcher
            switcherComponent={StateSwitcher}
            checked={checked}
            activateUrl={rule.activateUrl}
            deactivateUrl={rule.deactivateUrl}
            onResponse={(response) => this.refresh(response)}
          />
        </Cell>
        <Cell alignRight>{rule.id}</Cell>
        <Cell>
          <a href={rule.editPath}>{rule.name}</a>
        </Cell>
        <Cell>
          {_.map(rule.providers, (provider) => (
            <div key={provider}>{t(provider)}</div>
          ))}
        </Cell>
        <Cell>{this.renderAudiencesNames(rule.audience_ids)}</Cell>
        <Cell>
          <div>
            <Conditions t={t} conditions={rule.conditions} options={conditionOptions} isOnlyInfo />
            <br />
            <Action t={t} action={rule.action} options={actionOptions} isOnlyInfo />
          </div>
        </Cell>
        <Cell>
          <div>
            <div>
              <BoldText>{t('check_frequency')}</BoldText>
              {t(rule.action.check_frequency)}
            </div>
            {rule.checkedAt && (
              <div>
                <BoldText>{t('checked_at')}</BoldText>
                {rule.checkedAt}
              </div>
            )}
          </div>
          <br />
          <div>
            <div>
              <BoldText>{t('apply_frequency')}</BoldText>
              {t(rule.action.apply_frequency)}
            </div>
            {rule.appliedAt && (
              <div>
                <BoldText>{t('applied_at')}</BoldText>
                {rule.checkedAt}
              </div>
            )}
          </div>
        </Cell>
        <Cell alignRight>
          <Menu>
            <MenuLink href={rule.editPath}>
              <MenuItem>{t('edit')}</MenuItem>
            </MenuLink>
            <MenuItem onClick={() => onDelete(rule)}>{t('delete')}</MenuItem>
          </Menu>
        </Cell>
      </BodyRow>
    )
  }

  renderAudiencesNames(ids: Array<number>) {
    return (
      <div>
        {ids.map((id, index) => (
          <AudienceNameWrapper key={index}>
            <a href={`/audiences/${id}/edit`}>{this.audienceName(id)}</a>
          </AudienceNameWrapper>
        ))}
      </div>
    )
  }

  audienceName(id: number) {
    let audiences = _.flatten(
      _.map(this.props.audienceOptions, (groupedOptions) => {
        return groupedOptions.options
      })
    )
    let index = _.findIndex(audiences, { id: id })
    return index === -1 ? id : audiences[index].name
  }

  refresh(response: Object) {
    const { onChange } = this.props
    onChange(response.data.state)
  }
}
